import { ActionTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";

const videoActions: ActionTree<IPropertyEditState, {}> = <ActionTree<IPropertyEditState, {}>>{
}

export default videoActions;